import React, { FC } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { Breadcrumb } from 'src/Components/Breadcrumb'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'

export const TikTokVideoDetailsBreadcrumbs: FC = () => {
  const { campaignID } = useParams<{ campaignID: string }>()
  const navigate = useNavigate()

  const breadcrumbItems = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign Details',
      path: `${ArtistRoutesEnum.TiktokDetails}/${campaignID}`,
    },
    {
      title: 'Video details',
      path: '',
    },
  ]

  const onBreadcrumbButtonClick = (): void => {
    navigate(`${ArtistRoutesEnum.TiktokDetails}/${campaignID}`)
  }

  return (
    <Breadcrumb
      items={breadcrumbItems}
      onButtonClick={onBreadcrumbButtonClick}
    />
  )
}
